// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2k-A9","bigColWidth":"Table_bigColWidth__3sERW","biggerColWidth":"Table_biggerColWidth__24Iuz","row":"Table_row__9-7Z1","col":"Table_col__3S30C"};